<template>
  <div :class="$style.si">
    <svg
      viewBox="0 0 48 48"
      width="64"
      height="64"
      aria-hidden="true"
    >
      <path
        :class="$style['si-trace']"
        d="M24 14.5 L24 27"
        pathLength="1"
      ></path>
      <circle
        :class="$style['si-dot']"
        cx="24"
        cy="32.4"
        r="1.9"
      ></circle>
    </svg>
  </div>
</template>

<style
  lang="scss"
  module
>
.si {
  width: 64px;
  height: 64px;
  --mark: var(--warning-dark);
  --si-dur: 3s;
  border-radius: 50%;
  display: grid;
  place-items: center;
  flex: none;
  position: relative;
}

.si svg {
  display: block;
  overflow: visible;
}

.si-trace {
  fill: none;
  stroke: var(--mark);
  stroke-width: 3;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 1;
  animation: si-trace var(--si-dur) 1 forwards;
}

.si-dot {
  fill: var(--mark);
  transform-box: fill-box;
  transform-origin: center;
  animation: si-dot var(--si-dur) 1 forwards;
}

@keyframes si-trace {
  0% {
    stroke-dashoffset: 1;
    animation-timing-function: cubic-bezier(.6, 0, .2, 1);
  }
  30% {
    stroke-dashoffset: 0;
    animation-timing-function: linear;
  }
  70% {
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes si-dot {
  0%,
  34% {
    transform: scale(0);
    animation-timing-function: cubic-bezier(.34, 1.56, .64, 1);
  }
  46% {
    transform: scale(1);
  }
  84% {
    transform: scale(1);
  }
  100% {
    transform: scale(1);
  }
}

@media (prefers-reduced-motion: reduce) {
  .si-trace {
    stroke-dasharray: none;
    animation: none;
  }

  .si-dot {
    animation: none;
    transform: none;
  }
}
</style>
